import { Module } from "vuex";

/**
 * 项目案例-定制
 * @type {Module}
 */
export const custom = {
    namespaced: true,
    state: {
        // 用户个性化需求数据
        objUserCustomListData: [
            {
                title: "家庭成员特点",
                sub: 3,
                children: [
                    {
                        icon: require("@/assets/images/vr/common/family-0.png"),
                        text: [],
                    },
                    {
                        icon: require("@/assets/images/vr/common/family-1.png"),
                        text: [],
                    },
                ],
            },
            {
                title: "日常痛点及需求",
                sub: 2,
                children: [
                    {
                        icon: require("@/assets/images/vr/common/demand-0.png"),
                        text: [],
                    },
                    {
                        icon: require("@/assets/images/vr/common/demand-1.png"),
                        text: [],
                    },
                    {
                        icon: require("@/assets/images/vr/common/demand-2.png"),
                        text: [],
                    },
                    {
                        icon: require("@/assets/images/vr/common/demand-3.png"),
                        text: [],
                    },
                    {
                        icon: require("@/assets/images/vr/common/demand-4.png"),
                        text: [],
                    },
                ],
            },
            {
                title: "室温需求",
                sub: 4,
                children: [
                    {
                        icon: require("@/assets/images/vr/common/room-0.png"),
                        text: [],
                    },
                    {
                        icon: require("@/assets/images/vr/common/room-1.png"),
                        text: [],
                    },
                    {
                        icon: require("@/assets/images/vr/common/room-2.png"),
                        text: [],
                    },
                    {
                        icon: require("@/assets/images/vr/common/room-3.png"),
                        text: [],
                    },
                ],
            },
        ],
        // 设计参数数据
        objDesignParamsData: [
            {
                1: [
                    {
                        name: "空调面积",
                        key: "energy_hot_area",
                        value: "",
                        util: "㎡",
                    },
                    {
                        name: "采暖面积",
                        key: "energy_hot_area",
                        value: "",
                        util: "㎡",
                    },
                    {
                        name: "需求负荷",
                        key: "energy_cold",
                        value: "",
                        divide: 1000,
                        before: "冷",
                        util: "kW",
                    },
                    {
                        name: "需求负荷",
                        key: "energy_hot",
                        value: "",
                        divide: 1000,
                        before: "暖",
                        util: "kW",
                    },
                    {
                        name: "末端同开率",
                        key: "energy_percent",
                        value: "",
                        util: "%",
                    },
                ],
                3: [
                    {
                        name: "新风口",
                        value: "",
                        key: "numWindKou",
                        util: "个",
                    },
                    {
                        name: "换气面积",
                        value: "",
                        key: "numWindArea",
                        util: "㎡",
                    },
                    {
                        name: "换气频率",
                        value: "1",
                        key: "wind_exchange",
                        util: "次/小时",
                    },

                    // {
                    //   name: "新风需求量",
                    //   value: "223.8㎡/hp",
                    //   key: "wind_energy",
                    //   util: "㎡/hp",
                    // },
                ],
                4: [
                    {
                        name: "热水需求负荷",
                        value: "",
                        key: "water_energy",
                        util: "kW",
                    },
                    {
                        name: "最大净水用量",
                        key: "water_clean",
                        value: "",
                        util: "t/h",
                    },
                    {
                        name: "热水设计流量",
                        value: "",
                        key: "water_rate",
                        util: "L/min",
                    },
                    {
                        name: "最大软水用量",
                        value: "",
                        key: "water_soft",
                        util: "t/h",
                    },
                ],
            },
        ],
        // 产品数据
        arrProductInfo: [
            {
                img: '',
                name: "",
                id: '',
            },
        ],
        // 系统功能
        arrSystemFunctionList: [
            {
                name: "",
                video: '',
                cover: '',
                open: true,
                id: 0,
            },
        ],
        // 系统功能第一个视频ref
        objVideoRef: null,
        // 3D链接
        threeDLink:
            "https://bim.zhuxingyun.com/viewer?id=2ed6adc3b5f84f6391024894fbeb8439&tid=de2686a55e684b5a834dabdf57da712e",
    },
    mutations: {
        /**
         * 改变系统功能容器的展开状态
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_SYSTEM_FUNC_VISIBLE(state, typeAction) {
            const { id } = typeAction;
            state.arrSystemFunctionList = state.arrSystemFunctionList.map((i) => {
                if (i.id === id) {
                    i.open = !i.open;
                } else {
                    i.open = false;
                }
                return i;
            });
        },
        /**
         * 储存展开的视频ref
         * @param state
         * @param typeAction
         * @constructor
         */
        SAVE_FIRST_REF(state, typeAction) {
            const { ref } = typeAction;
            state.objVideoRef = ref ?? null;
        },
        /**
         * 改成产品数据
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_PRODUCT_LIST(state, typeAction) {
            const excludes = [216, 201];
            state.arrProductInfo = typeAction.list
                .filter((i) => !excludes.includes(i.new_goods_type_id))
                .map((i) => {
                    i.name = i.goods_name.includes("系统")
                        ? i.goods_name
                        : `${i.new_goods_type_name} ${i.goods_name}`;
                    i.img = i.mobile_img;
                    return i;
                });
        },
        /**
         * 保存3d链接
         * @param state
         * @param typeAction
         * @constructor
         */
        SAVE_3D_LINK(state, typeAction) {
            state.threeDLink = typeAction.link;
        },
        /**
         * 保存系统功能数据
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_SYSTEM_FUN(state, typeAction) {
            state.arrSystemFunctionList = typeAction.list.map((i, index) => {
                i.id = index;
                i.video = i.video_url;
                i.image = i.img_url;
                if (index === 0) {
                    i.open = true;
                    i.cover = i.video_cover;
                    i.coverIcon =
                        "https://pro-core.babycdn.com/2021/03aosmith/static/20211203/static/img/bg-play.png";
                }
                return i;
            });
        },
        /**
         * 保存设计参数数据
         */
        SAVE_DESIGN_PAR(state, typeAction) {
            const activeRoom = 0;
            let result = typeAction.list[activeRoom]?.product[0]?.items;
            if (result == undefined) {
                result = [];
            }
            const target = typeAction.list[activeRoom];
            for (const _index in state.objDesignParamsData[activeRoom]) {
                const index = Number.parseInt(_index);
                const sys = result.find((i) => i.system_id === index);
                if (!sys) delete state.objDesignParamsData[activeRoom][index];
                state.objDesignParamsData[activeRoom][index] =
                    state.objDesignParamsData[activeRoom][index]?.map((item) => {
                        const _value = Number.parseFloat(target[item.key]) || 0;
                        item.value = `${item.before ?? ""}${item.divide
                                ? (_value / item.divide)?.toFixed(1)
                                : item.key === "numWindKou"
                                    ? _value
                                    : _value?.toFixed(1)
                            }${item.util ?? ""}`;
                        return item;
                    });
            }
        },
        /**
         * 改变用户个性化需求
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_USER_CUSTOMER(state, typeAction) {
            state.objUserCustomListData = state.objUserCustomListData.map((i) => {
                let target = typeAction.list.find((j) => j.type_sub === i.sub);
                if (target == undefined) {
                    target = {
                        type_sub: 0,
                        type_sub_items: [],
                        type_sub_name: '',
                    }
                }
                return {
                    ...i,
                    title: target.type_sub_name,
                    children: target.type_sub_items.map((s) => ({
                        ...s,
                        icon: s.img,
                        text: [s.desc_sub],
                    })),
                };
            });
        },
    },
    actions: {
        /**
         * 整理报告信息
         */
        mapCustomerInfo({ rootState, commit }) {
            const { product, sub, tag_sub } = rootState.proposalModule.plantDetail;
            const { design_url, design_scheme, items } = rootState.proposalModule.projectDetail;
            commit({ type: "CHANGE_SYSTEM_FUN", list: design_scheme });
            commit({type: "CHANGE_PRODUCT_LIST", list: product ?? []});
            commit({type: "SAVE_DESIGN_PAR", list: sub ?? []});
            commit({type: "SAVE_3D_LINK", link: design_url});
            commit({type: "CHANGE_USER_CUSTOMER", list: tag_sub ?? []});
            commit(
                { type: "projectDetailConstruction/MAP_CATEGORY_LIST", list: items },
                { root: true }
            );
        },
    },
    getters: {},
};
